/**
 * Текстовый разделитель для Главной — между функциональными блоками и
 * «дополнительными сервисами».
 *
 * v0.4 (ADR-0023): простой centered muted text — без жёлтой полоски и линии.
 * Источник истины — `docs/prototypes/_design_spike/screen-home-spike.html`
 * (`MainContent` sep branch, lines 351-359).
 *
 * role="separator" сохранён для скринридеров.
 */
export interface SeparatorProps {
  label: string;
}

export function Separator({ label }: SeparatorProps) {
  return (
    <div
      role="separator"
      aria-label={label}
      className="text-center py-1.5 text-[11px] uppercase tracking-wider opacity-60 text-muted"
    >
      {label}
    </div>
  );
}
